/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digital_Presence_ExternalInputs */

const en_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Presence (External)`)
};

const es_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presencia digital (Externa)`)
};

const fr_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Présence numérique (Externe)`)
};

const de_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Präsenz (Extern)`)
};

const ja_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルプレゼンス (外部リンク)`)
};

const zh_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字足迹 (外部链接)`)
};

const ar_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التواجد الرقمي (خارجي)`)
};

const id_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehadiran Digital (Eksternal)`)
};

const it_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presenza Digitale (Esterna)`)
};

const ru_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровое присутствие (внешнее)`)
};

const pt_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presença Digital (Externa)`)
};

const ko_digital_presence_external = /** @type {(inputs: Digital_Presence_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 프레즌스 (외부 링크)`)
};

/**
* | output |
* | --- |
* | "Digital Presence (External)" |
*
* @param {Digital_Presence_ExternalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const digital_presence_external = /** @type {((inputs?: Digital_Presence_ExternalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digital_Presence_ExternalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_digital_presence_external(inputs)
	if (locale === "es") return es_digital_presence_external(inputs)
	if (locale === "fr") return fr_digital_presence_external(inputs)
	if (locale === "de") return de_digital_presence_external(inputs)
	if (locale === "ja") return ja_digital_presence_external(inputs)
	if (locale === "zh") return zh_digital_presence_external(inputs)
	if (locale === "ar") return ar_digital_presence_external(inputs)
	if (locale === "id") return id_digital_presence_external(inputs)
	if (locale === "it") return it_digital_presence_external(inputs)
	if (locale === "ru") return ru_digital_presence_external(inputs)
	if (locale === "pt") return pt_digital_presence_external(inputs)
	return ko_digital_presence_external(inputs)
});